import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ShortenedLinks() {
    const [links, setLinks] = useState([]);

    useEffect(() => {
        // Fetch shortened links from the backend
        async function fetchShortenedLinks() {
            try {
                const response = await axios.get('http://localhost:5000/api/links/');
                setLinks(response.data);
            } catch (error) {
                console.error('Error fetching shortened links:', error);
            }
        }

        fetchShortenedLinks();
    }, []);

    return (
        <div>
            <h2>Shortened Links</h2>
            <ul>
                {links.map(link => (
                    <li key={link.shortUrl}>
                        <p>Short URL: {link.shortUrl}</p>
                        <p>Long URL: {link.longUrl}</p> {/* Display longUrl */}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ShortenedLinks;
